import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ReportManagerComponent } from './report-manager.component';

@NgModule({
    declarations: [ReportManagerComponent],
    imports: [CommonModule, FormsModule, TranslateModule],
    exports: [ReportManagerComponent]
})
export class ReportManagerModule { }
